import $ from 'jquery';

class TextFacetView {

  constructor(config, $el, margins) {
    this._title = 'Text Chart';
    this._margins = margins;
    this._$input = $('<input type="text">').appendTo($el);
    this._$input.on('keyup', e => this._onKeyUp(e));
  }

  facet(facet) {
    if (!arguments.length) return this._facet;
    if (this._facet) {
      this._facet.dataChanged.remove(this._boundDataChanged);
      this._facet.selectionChanged.remove(this._boundSelectionChanged);
    }
    this._facet = facet;
    if (this._facet) {
      this._boundDataChanged = () => this._onDataChanged();
      this._boundSelectionChanged = (extent) => this._onSelectionChanged(extent);
      this._facet.dataChanged.add(this._boundDataChanged);
      this._facet.selectionChanged.add(this._boundSelectionChanged);
      this._updateSelection(null);
    }
    this.update();
    return this;
  }

  update() {}

  redraw() {}

  clear() {
    this._$input.val('');
    if (window.DEBUG) console.log(this._title + ': cleared');
  }

  _updateSelection(needle) {
    if (needle) this._$input.val(needle);
    else this._$input.val('');
  }

  _onKeyUp(e) {
    console.log('implement search');
    this._facet.filter(this._$input.val());
  }

  _onDataChanged() {
    if (window.DEBUG) console.log(this._title + ': data changed');
    // this._updateData();
  }

  _onSelectionChanged(extent) {
    this._updateSelection(extent);
  }

}

module.exports = TextFacetView;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/sidebar/archive/facets/TextFacetView.es6
 **/